"use strict"

/**
 * Flags for country select2 dropdowns.
 *
 * Shared by the application wizard and the status page so the two render a country the
 * same way. The flag file name travels on the option as data-flag; this module only knows
 * how to turn that into an image.
 */
window.CountryFlagSelect = (function () {
    // Production is hosted under a sub-path (/visa-debit). Image URLs do not pass through
    // the axios interceptor, so they must be prefixed via the layout's getApiUrl helper.
    const flagDirectory = function () {
        return typeof window.getApiUrl === 'function'
            ? window.getApiUrl('/media/flags/')
            : '/media/flags/'
    }

    /**
     * Built with DOM methods rather than an HTML string: select2 injects whatever it is
     * handed, and country names come from the database.
     */
    const buildRow = function (option, isSelection) {
        const element = option.element
        const flag = element ? element.getAttribute('data-flag') : null

        const row = document.createElement('span')
        row.className = isSelection ? 'country-pill' : 'country-option'

        if (flag) {
            const image = document.createElement('img')
            image.className = 'country-flag'
            image.src = flagDirectory() + flag
            // Decorative: the country name sits right beside it, so announcing the flag
            // as well would just read the country twice.
            image.alt = ''
            image.setAttribute('aria-hidden', 'true')
            // 260-odd flags render into the dropdown at once; only the ones actually
            // scrolled into view need fetching.
            image.loading = 'lazy'
            image.width = 20
            image.height = 14
            row.appendChild(image)
        } else {
            // Keeps the labels aligned when a country has no flag on file.
            const placeholder = document.createElement('span')
            placeholder.className = 'country-flag country-flag--missing'
            placeholder.setAttribute('aria-hidden', 'true')
            row.appendChild(placeholder)
        }

        const label = document.createElement('span')
        label.className = 'country-name'
        label.textContent = option.text
        row.appendChild(label)

        return row
    }

    return {
        templateResult: function (option) {
            // The search box and the "no results" row arrive here without an element.
            if (!option.id || !option.element) {
                return option.text
            }

            return window.jQuery(buildRow(option, false))
        },

        templateSelection: function (option) {
            if (!option.id || !option.element) {
                return option.text
            }

            return window.jQuery(buildRow(option, true))
        },

        /**
         * Adds flags to the wizard's destination select.
         *
         * The wizard's own initialisation lives inside a webpack bundle that is not
         * rebuilt in every environment, so this attaches from the outside instead: wait
         * for the countries to arrive, tag each option with its flag, then re-apply
         * select2 with the flag templates. jQuery change handlers the wizard bound to the
         * element survive a select2 destroy, so its validation keeps working.
         */
        attachToWizard: function () {
            const self = this
            const select = document.getElementById('destinationCountry')

            if (!select || !window.jQuery || !window.axios) {
                return
            }

            window.axios.get('/api/Country')
                .then(function (response) {
                    if (!response.data || !Array.isArray(response.data)) {
                        return
                    }

                    const flagsById = {}
                    response.data.forEach(function (country) {
                        if (country.flag) {
                            flagsById[String(country.id)] = country.flag
                        }
                    })

                    let applied = false

                    const apply = function () {
                        // The wizard populates the options asynchronously; nothing to do
                        // until they are actually there.
                        if (applied || select.options.length <= 1) {
                            return
                        }

                        let tagged = 0
                        Array.prototype.forEach.call(select.options, function (option) {
                            const flag = flagsById[option.value]
                            if (flag) {
                                option.setAttribute('data-flag', flag)
                                tagged += 1
                            }
                        })

                        if (tagged === 0) {
                            return
                        }

                        applied = true
                        observer.disconnect()

                        const $select = window.jQuery(select)
                        const selected = $select.val()

                        if ($select.hasClass('select2-hidden-accessible')) {
                            $select.select2('destroy')
                        }

                        $select.select2({
                            placeholder: 'Select Destination Country/Countries',
                            allowClear: true,
                            multiple: true,
                            minimumResultsForSearch: 10,
                            templateResult: self.templateResult,
                            templateSelection: self.templateSelection
                        })

                        // Re-applying select2 clears the rendered tokens; restore whatever
                        // was already chosen without firing change and re-running validation.
                        if (selected && selected.length) {
                            $select.val(selected).trigger('change.select2')
                        }
                    }

                    const observer = new MutationObserver(apply)
                    observer.observe(select, { childList: true })
                    apply()
                })
                .catch(function () {
                    // Flags are decoration. A failure here leaves the plain dropdown working.
                })
        },

        /** Convenience initialiser for plain selects outside the wizard. */
        enhance: function (selector, options) {
            const $select = window.jQuery(selector)
            if ($select.length === 0) {
                return
            }

            $select.select2(Object.assign({
                templateResult: this.templateResult,
                templateSelection: this.templateSelection,
                width: '100%'
            }, options || {}))
        }
    }
})()

document.addEventListener('DOMContentLoaded', function () {
    if (window.CountryFlagSelect) {
        window.CountryFlagSelect.attachToWizard()
    }
})
